import interceptor from '../common/interceptor';

// Product autocomplete API function
export const getProductAutocomplete = (
  token: string,
  searchText: string
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    params.append('q', searchText);

    const url = `/products/autocomplete/?${params.toString()}`;

    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error?.response);
      });
  });
};

// Product FDA information API function
export const getProductFDAInfo = (
  token: string,
  productName: string
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    params.append('name', productName);

    const url = `/products/fda-info/?${params.toString()}`;

    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error?.response);
      });
  });
};

// Product autofill information API function - NEW ENDPOINT
export const getProductAutofillInfo = (
  token: string,
  productName: string
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    params.append('name', productName);

    const url = `/products/autofill-info/?${params.toString()}`;

    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error?.response);
      });
  });
};
